import { Logo } from "@p0security/frontend-core/react";
import { PagerdutyIconUrl } from "@p0security/integrations-pagerduty-shared";
import { integrationRegistry } from "@p0security/shared/integrations/registry";
import { mapValues } from "lodash";
import type React from "react";

import { GrafanaIrmIconUrl, IncidentIoIconUrl } from "./constants.tsx";

/** Annotated rather than inferred: the inferred type is keyed on the
 * registry's literal keys, so a lookup by a runtime-derived key needs a cast.
 */
export const AllIntegrationLogos: Record<string, React.ReactNode> = {
  ...mapValues(integrationRegistry, ({ logoUrl, label }) => (
    <Logo logo={logoUrl} title={label} />
  )),
  pagerduty: <Logo logo={PagerdutyIconUrl} title="PagerDuty" />,
  incidentio: <Logo logo={IncidentIoIconUrl} title="Incident.io" />,
  "grafana-irm": <Logo logo={GrafanaIrmIconUrl} title="Grafana IRM" />,
};
